module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "rt-zoom-target"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    ref: "tooltip",
    class: _vm.tooltipCalssName,
    style: (_vm.tooltipStyle)
  }, [_c('span', {
    staticClass: "tooltip-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    ref: "arrow",
    staticClass: "popper__arrow",
    class: _vm.placement === 'top' ? 'popper__arrow_bottom' : '',
    style: (_vm.arrowStyle)
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c254c5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/tooltip/rtTooltipGlobal.vue
// module id = 2101
// module chunks = 137